export default "__VITE_ASSET__BWAgplYP__"